import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { selectConfig } from '../../modules/config/config.selector';
import { Observable } from 'rxjs/Observable';
import { selectUrlParams } from '../../modules/url-params/url-params.selector';
import { ConfigModel } from '../../modules/config/config.model';
import { UrlParams } from '../../modules/url-params/model/url-params.model';
import { SourceAppService } from './source-app.service';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/combineLatest';

/**
 * Service handling token invalidation before logout.
 */
@Injectable()
export class TokenRestClient {
    revokeUrl: string;
    accessToken: string;

    constructor(private http: HttpClient, private store: Store<AppState>, private sourceService: SourceAppService) {
        this.store.select(selectConfig)
            .combineLatest(this.store.select(selectUrlParams))
            .filter(([config, urlParams]: ([ConfigModel, UrlParams])) => !!config  &&  !!urlParams)
            .subscribe(([config, urlParams]: ([ConfigModel, UrlParams])) => {
                if (!sourceService.isFromCps()) {
                    this.revokeUrl = config ? config.apiUrl.revokeToken : null;
                }
                this.accessToken = urlParams.access_token;
            });
    }

    private commonHeaders() {
        return new HttpHeaders()
            .set('Authorization', 'Bearer' + ' ' + this.accessToken);
    }

    private mepHeaders() {
        return this.commonHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded');
    }

    /**
     * Function invalidates the access token before logout. The actual endpoint used depends on the origin app, that was
     * used to navigate to self-service.
     */
    public revokeToken(): Observable<any> {
        if (this.sourceService.isFromCps()) {
            // ADFS2019 does not have revoke token
            return Observable.empty();
        } else {
            return this.http.post<any>(this.revokeUrl, 'token=' + this.accessToken, { headers: this.mepHeaders() });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/services/token-rest-client.service.ts